import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactDOM from "react-dom";
import {
  Submenu,
  Spinner,
  ImageItem,
  AddDecorationButton,
  Containerframes,
} from "./ImageViewStyles.js";
import { usePhotos } from "../../Redux/PhotosContext.js";

import applyFilterToImages from "../../Components/Frames/applyFilterToImages.js";
import styled from "styled-components";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const CheckedIcon = styled.div`
  position: absolute;
  top: 23px;
  left: 25px; /* Adjust as needed */
  z-index: 10; /* Ensure the icon is above the image */
  color: rgba(0, 0, 0, 0.5);
`;
const SubmenuFrames = ({
  photos,
  setPhotos,
  highlightedImages,
  originalImages,
  setOriginalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  setApprovedImages,
}) => {
  const logo = useSelector((state) => state.user.logo?.url);

  const {
    allFrames: allframes,
    loadingFrames: loading,
    fetchFrames,
  } = usePhotos();

  const [selectedFrameId, setSelectedFrameId] = useState(null); // Track selected frame

  const handleImageClick = (frameId) => {
    setSelectedFrameId((prevId) => (prevId === frameId ? null : frameId)); // Toggle selection
  };

  useEffect(() => {
    if (allframes.length === 0 && !loading) {
      fetchFrames();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allframes]);

  return ReactDOM.createPortal(
    <>
      <Containerframes>
        <Submenu style={{ height: "300px" }}>
          {allframes.length === 0 ? (
            <Spinner message="Loading frames..." /> // Enhanced loading message
          ) : allframes.length > 0 ? (
            <>
              {allframes.map((frame) => (
                <div key={frame.id} style={{ position: "relative" }}>
                  {frame.filters.preview ? (
                    <>
                      {selectedFrameId === frame.id && (
                        <CheckedIcon>
                          <CheckBoxIcon
                            onClick={() => handleImageClick(frame.id)}
                            sx={{ transform: "scale(1.4)" }}
                          />
                        </CheckedIcon>
                      )}
                      <ImageItem
                        src={frame.filters.preview.image}
                        alt={`Frame ${frame.id} Preview`}
                        onClick={() => handleImageClick(frame.id)}
                        style={{
                          filter:
                            selectedFrameId === frame.id ? "blur(1px)" : "none", // Apply blur only when selected
                        }}
                      />
                    </>
                  ) : (
                    <p>No preview available</p>
                  )}
                </div>
              ))}
            </>
          ) : (
            <p>No frames available</p>
          )}
        </Submenu>
        <AddDecorationButton
          disabled={!selectedFrameId}
          onClick={() =>
            applyFilterToImages(
              selectedFrameId,
              allframes,
              photos,
              setPhotos,
              highlightedImages,
              originalImages,
              originalImagesLogo,
              setOriginalImagesLogo,
              () => {},
              setApprovedImages,
              logo
            )
          }
        >
          Add Decoration
        </AddDecorationButton>
      </Containerframes>
    </>,
    document.body
  );
};

export default SubmenuFrames;
